import { z } from 'zod';
import * as directoryScheme from './directoryScheme';
import * as imageSchema from './imageSchema';

export const nameHelper =
  'Client name is required. It must have at least 2 characters, max 300 characters, no special characters allowed';
export const nameSchema = directoryScheme.createNameSchema({
  name: 'Client Name',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

export const phoneHelper = directoryScheme.phoneHelperOptional;
export const phoneSchema = directoryScheme.phoneSchema.optional();

export const emailHelper = directoryScheme.emailHelperOptional;
export const emailSchema = directoryScheme.emailSchema.optional();

export const addressHelper = directoryScheme.addressHelperOptional;
export const addressSchema = directoryScheme.addressSchema.optional();

export const countryHelper = directoryScheme.countryHelperOptional;
export const countrySchema = directoryScheme.countrySchema.optional();

export const zipcodeHelper = directoryScheme.zipcodeHelperOptional;
export const zipcodeSchema = directoryScheme.zipcodeSchema.optional();

export const clientSchema = z.object({
  id: directoryScheme.idSchema,
  name: nameSchema,
  phone: phoneSchema,
  email: emailSchema,
  country: countrySchema,
  address: addressSchema,
  zipcode: zipcodeSchema,
});

export const clientPartialSchema = clientSchema.partial();
